import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Label } from '@/components/ui/label';

export const MAINTENANCE_SELECT_TRIGGER_CLASS = 'w-full min-h-11';

const ALL_VALUE = '__all__';

const PICK_VALUE = '__pick__';

export function MaintenanceRequiredSelect({
  label,
  id,
  value,
  onValueChange,
  placeholder = 'Bitte wählen …',
  items,
  disabled,
}: {
  label: string;
  id?: string;
  value: string;
  onValueChange: (value: string) => void;
  placeholder?: string;
  items: { value: string; label: string }[];
  disabled?: boolean;
}) {
  return (
    <div className="min-w-0 space-y-2">
      <Label htmlFor={id}>{label}</Label>
      <Select
        value={value || PICK_VALUE}
        onValueChange={(next) => {
          if (next !== PICK_VALUE) {
            onValueChange(next);
          }
        }}
        disabled={disabled}
      >
        <SelectTrigger id={id} className={MAINTENANCE_SELECT_TRIGGER_CLASS}>
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value={PICK_VALUE} disabled>
            {placeholder}
          </SelectItem>
          {items.map((item) => (
            <SelectItem key={item.value} value={item.value}>
              {item.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}

export function MaintenanceOptionalSelect({
  label,
  id,
  value,
  onValueChange,
  emptyLabel = 'Alle',
  items,
  disabled,
}: {
  label: string;
  id?: string;
  value: string;
  onValueChange: (value: string) => void;
  emptyLabel?: string;
  items: { value: string; label: string }[];
  disabled?: boolean;
}) {
  return (
    <div className="min-w-0 space-y-2">
      <Label htmlFor={id}>{label}</Label>
      <Select
        value={value || ALL_VALUE}
        onValueChange={(next) => onValueChange(next === ALL_VALUE ? '' : next)}
        disabled={disabled}
      >
        <SelectTrigger id={id} className={MAINTENANCE_SELECT_TRIGGER_CLASS}>
          <SelectValue placeholder={emptyLabel} />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value={ALL_VALUE}>{emptyLabel}</SelectItem>
          {items.map((item) => (
            <SelectItem key={item.value} value={item.value}>
              {item.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
